export default {
    addAttribute(state, attribute) {
        if (!state.post.attributes.hasOwnProperty(attribute.id)) {
            state.post.attributes[attribute.id] = {}
        }

        state.post.attributes[attribute.id] = attribute
    },

    setSending(state, sending) {
        state.sending = sending
    },
    setPosts(state, posts) {
        state.posts = posts
    },
    setPostView(state, post) {
        state.postView = post
    },
    setUnreadMessage(state, data) {
        state.unread_messages = data
    }
}
